function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import StringBuffer from '../../../../java/lang/StringBuffer';
import Location from '../geom/Location';
import Position from './Position';
import TopologyException from '../geom/TopologyException';
import System from '../../../../java/lang/System';
import SimplePointInAreaLocator from '../algorithm/locate/SimplePointInAreaLocator';
import ArrayList from '../../../../java/util/ArrayList';
import Assert from '../util/Assert';
import TreeMap from '../../../../java/util/TreeMap';
var EdgeEndStar = /*#__PURE__*/function () {
  function EdgeEndStar() {
    _classCallCheck(this, EdgeEndStar);
    EdgeEndStar.constructor_.apply(this, arguments);
  }
  return _createClass(EdgeEndStar, [{
    key: "getNextCW",
    value: function getNextCW(ee) {
      this.getEdges();
      var i = this._edgeList.indexOf(ee);
      var iNextCW = i - 1;
      if (i === 0) iNextCW = this._edgeList.size() - 1;
      return this._edgeList.get(iNextCW);
    }
  }, {
    key: "propagateSideLabels",
    value: function propagateSideLabels(geomIndex) {
      var startLoc = Location.NONE;
      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        var label = e.getLabel();
        if (label.isArea(geomIndex) && label.getLocation(geomIndex, Position.LEFT) !== Location.NONE) startLoc = label.getLocation(geomIndex, Position.LEFT);
      }
      if (startLoc === Location.NONE) return null;
      var currLoc = startLoc;
      for (var _it = this.iterator(); _it.hasNext();) {
        var _e = _it.next();
        var _label = _e.getLabel();
        if (_label.getLocation(geomIndex, Position.ON) === Location.NONE) _label.setLocation(geomIndex, Position.ON, currLoc);
        if (_label.isArea(geomIndex)) {
          var leftLoc = _label.getLocation(geomIndex, Position.LEFT);
          var rightLoc = _label.getLocation(geomIndex, Position.RIGHT);
          if (rightLoc !== Location.NONE) {
            if (rightLoc !== currLoc) throw new TopologyException('side location conflict', _e.getCoordinate());
            if (leftLoc === Location.NONE) {
              Assert.shouldNeverReachHere('found single null side (at ' + _e.getCoordinate() + ')');
            }
            currLoc = leftLoc;
          } else {
            Assert.isTrue(_label.getLocation(geomIndex, Position.LEFT) === Location.NONE, 'found single null side');
            _label.setLocation(geomIndex, Position.RIGHT, currLoc);
            _label.setLocation(geomIndex, Position.LEFT, currLoc);
          }
        }
      }
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      var it = this.iterator();
      if (!it.hasNext()) return null;
      var e = it.next();
      return e.getCoordinate();
    }
  }, {
    key: "print",
    value: function print(out) {
      System.out.println('EdgeEndStar:   ' + this.getCoordinate());
      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        e.print(out);
      }
    }
  }, {
    key: "isAreaLabelsConsistent",
    value: function isAreaLabelsConsistent(geomGraph) {
      this.computeEdgeEndLabels(geomGraph.getBoundaryNodeRule());
      return this.checkAreaLabelsConsistent(0);
    }
  }, {
    key: "checkAreaLabelsConsistent",
    value: function checkAreaLabelsConsistent(geomIndex) {
      var edges = this.getEdges();
      if (edges.size() <= 0) return true;
      var lastEdgeIndex = edges.size() - 1;
      var startLabel = edges.get(lastEdgeIndex).getLabel();
      var startLoc = startLabel.getLocation(geomIndex, Position.LEFT);
      Assert.isTrue(startLoc !== Location.NONE, 'Found unlabelled area edge');
      var currLoc = startLoc;
      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        var label = e.getLabel();
        Assert.isTrue(label.isArea(geomIndex), 'Found non-area edge');
        var leftLoc = label.getLocation(geomIndex, Position.LEFT);
        var rightLoc = label.getLocation(geomIndex, Position.RIGHT);
        if (leftLoc === rightLoc) {
          return false;
        }
        if (rightLoc !== currLoc) {
          return false;
        }
        currLoc = leftLoc;
      }
      return true;
    }
  }, {
    key: "findIndex",
    value: function findIndex(eSearch) {
      this.iterator();
      for (var i = 0; i < this._edgeList.size(); i++) {
        var e = this._edgeList.get(i);
        if (e === eSearch) return i;
      }
      return -1;
    }
  }, {
    key: "iterator",
    value: function iterator() {
      return this.getEdges().iterator();
    }
  }, {
    key: "getEdges",
    value: function getEdges() {
      if (this._edgeList === null) {
        this._edgeList = new ArrayList(this._edgeMap.values());
      }
      return this._edgeList;
    }
  }, {
    key: "getLocation",
    value: function getLocation(geomIndex, p, geom) {
      if (this._ptInAreaLocation[geomIndex] === Location.NONE) {
        this._ptInAreaLocation[geomIndex] = SimplePointInAreaLocator.locate(p, geom[geomIndex].getGeometry());
      }
      return this._ptInAreaLocation[geomIndex];
    }
  }, {
    key: "toString",
    value: function toString() {
      var buf = new StringBuffer();
      buf.append('EdgeEndStar:   ' + this.getCoordinate());
      buf.append('\n');
      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        buf.append(e);
        buf.append('\n');
      }
      return buf.toString();
    }
  }, {
    key: "computeEdgeEndLabels",
    value: function computeEdgeEndLabels(boundaryNodeRule) {
      for (var it = this.iterator(); it.hasNext();) {
        var ee = it.next();
        ee.computeLabel(boundaryNodeRule);
      }
    }
  }, {
    key: "computeLabelling",
    value: function computeLabelling(geomGraph) {
      this.computeEdgeEndLabels(geomGraph[0].getBoundaryNodeRule());
      this.propagateSideLabels(0);
      this.propagateSideLabels(1);
      var hasDimensionalCollapseEdge = [false, false];
      for (var it = this.iterator(); it.hasNext();) {
        var e = it.next();
        var label = e.getLabel();
        for (var geomi = 0; geomi < 2; geomi++) {
          if (label.isLine(geomi) && label.getLocation(geomi) === Location.BOUNDARY) hasDimensionalCollapseEdge[geomi] = true;
        }
      }
      for (var _it2 = this.iterator(); _it2.hasNext();) {
        var _e2 = _it2.next();
        var _label2 = _e2.getLabel();
        for (var _geomi = 0; _geomi < 2; _geomi++) {
          if (_label2.isAnyNull(_geomi)) {
            var loc = Location.NONE;
            if (hasDimensionalCollapseEdge[_geomi]) {
              loc = Location.EXTERIOR;
            } else {
              var p = _e2.getCoordinate();
              loc = this.getLocation(_geomi, p, geomGraph);
            }
            _label2.setAllLocationsIfNull(_geomi, loc);
          }
        }
      }
    }
  }, {
    key: "getDegree",
    value: function getDegree() {
      return this._edgeMap.size();
    }
  }, {
    key: "insertEdgeEnd",
    value: function insertEdgeEnd(e, obj) {
      this._edgeMap.put(e, obj);
      this._edgeList = null;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EdgeEndStar;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { EdgeEndStar as default };
EdgeEndStar.constructor_ = function () {
  this._edgeMap = new TreeMap();
  this._edgeList = null;
  this._ptInAreaLocation = [Location.NONE, Location.NONE];
};